import { Module } from '@nestjs/common';
import { AuthModule } from '../auth/auth.module';
import { InvoiceNumberService } from './invoice-number.service';
import { InvoiceLinkService } from './invoice-link.service';
import { InvoicePdfService } from './invoice-pdf.service';
import { InvoiceRendererService } from './invoice-renderer.service';
import { InvoiceService } from './invoice.service';
import { InvoicesController } from './invoices.controller';

/**
 * Invoicing.
 *
 * `InvoiceService` (issue) and `InvoicePdfService` (print) are exported because
 * the email path needs both: the order-confirmation mail attaches the PDF, and
 * that is usually the first thing to ask for it — which is what keeps rendering
 * off the customer's critical path without a queue existing.
 */
@Module({
  imports: [AuthModule],
  controllers: [InvoicesController],
  providers: [
    InvoiceService, InvoiceNumberService, InvoicePdfService, InvoiceRendererService,
    InvoiceLinkService,
  ],
  exports: [InvoiceService, InvoicePdfService, InvoiceLinkService],
})
export class InvoicesModule {}
